export default {
  QUILL: 'quill',
  JODIT: 'jodit'
}
